import {colors} from './colors'

const certStatusOptions = {
    valid: {
        status: 'valid',
        label: 'Valid',
        color: colors.colorGreen
    },
    creation_failed: {
        status: 'creation_failed',
        label: 'Creation failed',
        color: colors.colorRed
    },
    expired: {
        status: 'expired',
        label: 'Expired',
        color: colors.colorRed
    },
    pending: {
        status: 'pending',
        label: 'Pending',
        color: colors.colorOrange
    },
    not_available: {
        status: 'not_available',
        label: 'Not available',
        color: colors.colorBgFilter
    }
}

const getSslIconColor = (domain, cert) => {
    if (!domain) {
        return colors.colorGreen
    }

    if (!cert) {
        return colors.colorBgFilter
    }

    return certStatusOptions[cert?.status]?.color
}

const getSslTooltipText = (domain, cert) => {
    if (!domain) {
        return certStatusOptions.valid.label
    }

    if (!cert) {
        return certStatusOptions.not_available.label
    }

    return certStatusOptions[cert?.status]?.label
}

export {
    getSslIconColor,
    getSslTooltipText
}
